import axios from '@/plugins/axios'
import {
    setAuthToken,
    Logout as clearSessionLogout
} from "@/utils/user.utils"
import {
    makeVueBasicPlugin
} from "@/utils/vue.utils";
import {
    CookieRemove,
} from "@/utils/cookie.utils";
import actions from "@/store/actions";

export const api = {
    /**
     * Get Posts
     */
    getPosts(limit = 50, page = 1) {
        return axios.get(`/api/v1/posts?limit=${limit}&page=${page}`).then(({
            data
        }) => data)
    },
    /**
     * Get Events
     */
    getEvents(limit = 30, page = 1) {
        return axios.get(`/api/v1/events?limit=${limit}&page=${page}`).then(({
            data
        }) => data)
    },
    /**
     * Get notes
     */
    getNotes(limit = 30, page = 1) {
        return axios.get(`/api/v1/notes?limit=${limit}&page=${page}`).then(({
            data
        }) => data)
    },
    /**
     * Get guides
     */
    getGuides(limit = 50, page = 1) {
        return axios.get(`/api/v1/guides?limit=${limit}&page=${page}`).then(({
            data
        }) => data)
    },
    /**
     * Get goods shop
     */
    getGoodsShopProducts(limit = 8, page = 1) {
        return axios.get(`/api/v1/shopify-products?limit=${limit}&page=${page}`).then(({
            data
        }) => data.items || [])
    },
    /**
     * Get authenticated user
     */
    getAuthUser() {
        return axios.get('/v1/profile').then(({
                data
            }) => data)
            .then((user) => {
                actions.updateUser(user)
                return user
            })
    },
    /**
     * Get user ZP
     */
    getZP() {
        return axios.get('/v1/profile/zp').then(({
            data
        }) => {
            actions.updateZP(data.points)
            return data;
        })
    },
    /**
     * Get total donations
     */
    getTotalDonations() {
        return axios.get('/api/v1/orders/total').then(({
            data
        }) => data)
    },
    /**
     * Get shop packages
     */
    getShopPacks(category) {
        return axios.get(`/api/v1/shop/${category}`).then(({
            data
        }) => {
            return data
        })
    },
    /**
     * Buy shop packages
     */
    BuyShopPack(cartItems, charId) {
        return axios.post(`/v1/shop`, {
            charId,
            packs: cartItems
        }).then(({
            data
        }) => {
            return data
        })
    },
    /**
     * Get transactions
     */
    getTransactions() {
        return axios.get('/v1/orders').then(({
            data
        }) => {
            return data;
        })
    },
    /**
     * Get Order
     */
    getOrder(id) {
        return axios.get(`/v1/order/${id}`).then(({
            data
        }) => data)
    },
    /**
     * Get pack transactions
     */
    getPackTransactioons() {
        return axios.get('/v1/packs/orders').then(({
            data
        }) => {
            return data;
        })
    },
    /**
     * Completed checkout
     */
    makeCompletedCheckout(provider, orderId) {
        return axios.get(`/v1/checkout/${provider}/completed/${orderId}`).then(({
            data
        }) => data)
    },
    /**
     * Cancelled checkout
     */
    makeCancelledCheckout(provider, orderId) {
        return axios.get(`/v1/checkout/${provider}/cancelled/${orderId}`).then(({
            data
        }) => data)
    },
    /**
     * Change user password
     */
    changePassword(currentPassword, newPassword) {
        return axios.post('/v1/profile/modify-password', {
            currentPassword,
            newPassword
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Completing oAuth Profile
     */
    completeOAuthProfile(username, email, password, acceptMarketingNews) {
        return axios.post('/v1/profile/complete-oauth-profile', {
            username,
            email,
            password,
            acceptMarketingNews
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Verify email
     */
    verifyEmail() {
        return axios.get('/v1/profile/verify-email').then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Get config
     */
    getConfig() {
        return axios.get('/api/v1/config').then(({
            data
        }) => data);
    },
    /**
     * Logout
     */
    logout() {
        return axios.post('/logout')
            .then(() => {
                // store
                clearSessionLogout();
            })
            .catch(() => {
                // store
                clearSessionLogout();
            });
    },
    /**
     * Get total online
     */
    getTotalInGameOnline() {
        return axios.get('/api/v1/total-online-ingame').then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Get game characters from string
     * @param string str
     */
    getGameCharactersFromString(str) {
        return axios.get(`/api/v1/search/game-character/${str}`)
            .then(({
                data
            }) => {
                return data;
            });
    },
    /**
     * Get characters belonging to current user
     */
    getCurrentUserGameChars() {
        return axios.get(`/v1/profile/game-character`)
            .then(({
                data
            }) => {
                return data;
            });
    },
    /**
     * Gift zushin points to someone
     * @param string charName
     * @param int points
     */
    sendZushinPoints(charName, points) {
        return axios.put(`/v1/gift/points/${charName}`, {
                points
            })
            .then(({
                data
            }) => {
                return data;
            });
    },
    /**
     * Update language locale
     */
    updateLanguage(code) {
        localStorage.setItem('locale-goz', code)

        return axios.get(`/locale/${code}`)
            .then(({
                data
            }) => {
                return data;
            })
    },
    /**
     * Handle ipn after authoruzed from paypal checkout
     * @param int price
     */
    onAuthorizedPayPalCheckout(ipnUrl, paypalOrderId, authId) {
        return axios.post(ipnUrl, {
            paypalOrderId,
            authId
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Do paypal checkout
     * @param int price
     */
    doPayPalCheckout(price) {
        return axios.post('/v1/paypal/checkout', {
            price
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Do stripe checkout
     * @param int orderId
     */
    doStripeCheckout(orderId, paymentType) {
        return axios.post(`/v1/stripe/checkout/${orderId}`, {
            paymentType
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Do paypal update order
     * @param int orderId
     * @param int price
     */
    doPayPalUpdateOrder(orderId, price) {
        return axios.put(`/v1/paypal/update/${orderId}`, {
            price
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Do paypal delete order
     * @param int orderId
     */
    doPayPalDeleteOrder(orderId) {
        return axios.delete(`/v1/paypal/delete/${orderId}`).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Deactivate a user
     */
    ChangeDeactivatedUser() {
        return axios.put(`/v1/user/deactivate`).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Change email notifications preferences
     * @param bool hasOrdersEmailNotification
     * @param bool hasAuthenticatedEmailNotification
     * @param bool hasGiftsNotifications
     */
    ChangeEmailNotificationPreferences(userId, hasOrdersEmailNotification, hasAuthenticatedEmailNotification, hasGiftsNotifications, hasMarketingNews) {
        return axios.put(`/v1/user/change-preferences/${userId}`, {
            hasOrdersEmailNotification: +hasOrdersEmailNotification,
            hasAuthenticatedEmailNotification: +hasOrdersEmailNotification,
            hasGiftsNotifications: +hasGiftsNotifications,
            hasMarketingNews: +hasMarketingNews,
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Get user preferences
     */
    GetUserPreferences() {
        return axios.get('/v1/user/preferences').then(({
            data
        }) => data);
    },
    /**
     * Get user restrictions
     */
    GetUserRestrictions() {
        return axios.get('/v1/user/restrictions').then(({
            data: restrictions
        }) => {
            actions.updateUserRestrictions(restrictions)
            return restrictions;
        });
    },
    /**
     * Get notifications
     */
    getNotifications() {
        return axios.get('/v1/notifications').then(({
            data
        }) => data);
    },
    /**
     * Mark notification
     */
    markNotification(id) {
        return axios.get(`/v1/mark-notification/${id}`).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Clear all notifications
     */
    clearNotifications() {
        return axios.get('/v1/clear-notifications').then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * SignIn
     */
    login(username, password) {
        return axios.post('/login', {
                email: username,
                password
            })
            .then(async({ data: { token }}) => {
                setAuthToken(token);
            })
            .then(async() => await this.getAuthUser())
            .then(async() => await this.getZP())
            .then(async() => await this.GetUserRestrictions());
    },
    /**
     * SignUp
     */
    register(username, nickname, email, password, confirmPassword, acceptMarketingNews) {
        return axios.post('/register', {
                username,
                nickname,
                email,
                password,
                password_confirmation: confirmPassword,
                acceptMarketingNews,
            })
            .then(async({ data: { token }}) => {
                // remove cookie
                CookieRemove("referralId");
                setAuthToken(token);
            })
            .then(async() => await this.getAuthUser())
            .then(async() => await this.getZP())
            .then(async() => await this.GetUserRestrictions());
    },
    /**
     * Rapid SignUp
     */
    rapidRegister(email, acceptMarketingNews) {
        return axios.post('/rapid-register', {
                email,
                acceptMarketingNews,
            })
            .then(async({ data: { token }}) => {
                setAuthToken(token);
            })
            .then(this.getAuthUser)
            .then(this.getZP)
            .then(this.GetUserRestrictions);
    },
    /**
     * Reset link
     */
    resetLink(username) {
        return axios.post('/password/email', {
            email: username,
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /**
     * Reset link
     */
    resetPassword(email, password, confirmPassword, token) {
        return axios.post('/password/reset', {
            email,
            password,
            password_confirmation: confirmPassword,
            token
        }).then(({
            data
        }) => {
            return data;
        });
    },
    /** Google Sheet: Get Component Groups | Disenchantment */
    getDisenchantableItems() {
        return axios.get('https://docs.google.com/spreadsheets/d/e/2PACX-1vRfdwJTHoMamDOjgcCPLWylsb6uYbSKDBCC-bn5klygnSJwuQe4IIpDLjYdvTeKNIijcNVlAnbFayEG/pub?gid=0&single=true&output=csv')
        .then(({ data }) => data)
    },
    getDisenchantmentObtainMaterials() {
        return axios.get('https://docs.google.com/spreadsheets/d/e/2PACX-1vTo-JmfxWt2-qPil6MdPQ8EuNaoHOjdNVA03huq3Gb9vSxk9Eh5THlrpcUoQrlHhrN4zSmssvTG3ArC/pub?gid=0&single=true&output=csv')
        .then(({ data }) => data)
    }
}

export default makeVueBasicPlugin("$api", api);
